var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6052 5.35965C9.74118 3.32663 7.39267 2.37897 5.35965 3.24298C3.32663 4.10699 2.37897 6.4555 3.24298 8.48852C4.10699 10.5215 6.4555 11.4692 8.48852 10.6052C8.96423 10.403 9.38051 10.1196 9.72807 9.7779C9.73568 9.76904 9.74369 9.7604 9.75209 9.752C9.76041 9.74368 9.76897 9.73575 9.77774 9.7282C10.8774 8.60824 11.2573 6.89408 10.6052 5.35965ZM10.7168 10.0641C11.8509 8.69189 12.1991 6.75012 11.4547 4.99861C10.3913 2.49641 7.50081 1.33004 4.99861 2.39345C2.49641 3.45686 1.33004 6.34736 2.39345 8.84956C3.45686 11.3518 6.34736 12.5181 8.84956 11.4547C9.29937 11.2636 9.706 11.0134 10.0643 10.717L13.2121 13.8652C13.3923 14.0455 13.6845 14.0455 13.8648 13.8653C14.045 13.6851 14.0451 13.3928 13.8648 13.2126L10.7168 10.0641Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.d35c0bae4acf2e9622be021f176cadc5.svg";
export { ForwardRef as ReactComponent };